import { useEffect, useLayoutEffect, useRef, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import * as cts from '../../../constants/ui/svg';
import { Switch, Input, Modal } from 'antd';
import { IMAGE_BASE_URL_OF_USER_RANK } from '../../../constants';
import DraggableImage from './DraggableImage';
import { Area } from 'react-easy-crop';
import AspectWrapper from './AspectWrapper';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { rankingAction } from 'slices/rankingSlice';
import { getToken } from 'helpers';

type Props = {
  selectedStaff: any;
  images: any[];
  setImages: React.Dispatch<React.SetStateAction<any[]>>;
  tab: number;
};
export default function ContentModalSlide({ selectedStaff, images, setImages, tab }: Props) {
  const { t } = useTranslation();
  const token = getToken() as string;
  const dispatch = useAppDispatch();
  const containerRef = useRef<HTMLDivElement>(null);

  const selectShop = useAppSelector((state) => state.shopList.selectShop);
  const imageShowRank = useAppSelector((state) => state.ranking.imageShowRank);

  const [imageError, setImageError] = useState<{ [key: string]: boolean }>({});
  const [aspect, setAspect] = useState<number | null>(null);

  const imageShowRank_2 =
    typeof selectedStaff?.imageUrl === 'string' && selectedStaff.imageUrl.trim() !== ''
      ? []
      : tab === 2
        ? imageShowRank.filter((x: any, y: any) => x?.type == 2)
        : imageShowRank.filter((x: any, y: any) => x?.type == 1);

  const handleImageError = (idHost: string) => {
    setImageError((prev) => ({ ...prev, [idHost]: true }));
  };
  // -------------------TAB===2----------------------
  const top1 = useMemo(() => {
    return images.slice(0, 1)[0] || null;
  }, [images]);
  const top2_3 = useMemo(() => {
    return images.slice(1, 3);
  }, [images]);
  // Lấy top 4-5
  const top4_5 = useMemo(() => {
    return images.slice(3, 5);
  }, [images]);
  const top6_7 = useMemo(() => {
    return images.slice(5, 7);
  }, [images]);
  // Lấy top 8-9-10
  const top8_9_10 = useMemo(() => {
    return images.slice(7, 10);
  }, [images]);

  const top1_img: any = imageShowRank_2.slice(0, 1)[0] || null;
  const top2_3_img: any = imageShowRank_2.slice(1, 3);
  // Lấy top 4-5
  const top4_5_img: any = imageShowRank_2.slice(3, 5);
  const top6_7_img: any = imageShowRank_2.slice(5, 7);
  // Lấy top 8-9-10
  const top8_9_10_img: any = imageShowRank_2.slice(7, 10);
  // -----------------TAB===3--------------------------
  const top1_square = useMemo(() => {
    return images.slice(10, 11)[0] || null;
  }, [images]);
  const top2_3_square = useMemo(() => {
    return images.slice(11, 13);
  }, [images]);
  // Lấy top 4-5
  const top4_5_square = useMemo(() => {
    return images.slice(13, 15);
  }, [images]);
  const top6_7_square = useMemo(() => {
    return images.slice(15, 17);
  }, [images]);
  // Lấy top 8-9-10
  const top8_9_10_square = useMemo(() => {
    return images.slice(17, 20);
  }, [images]);

  const top1_img_square: any = imageShowRank_2.slice(0, 1)[0] || null;
  const top2_3_img_square: any = imageShowRank_2.slice(1, 3);
  // Lấy top 4-5
  const top4_5_img_square: any = imageShowRank_2.slice(3, 5);
  const top6_7_img_square: any = imageShowRank_2.slice(5, 7);
  // Lấy top 8-9-10
  const top8_9_10_img_square: any = imageShowRank_2.slice(7, 10);
  useEffect(() => {
    if (containerRef.current) {
      const { clientWidth, clientHeight } = containerRef.current;
      const newAspect = clientWidth / clientHeight;
      setAspect(newAspect);
    }
  }, []);
  useEffect(() => {
    if (selectedStaff?.id) {
      dispatch(
        rankingAction.getImageShowRanking({
          token,
          params: { shop_id: selectShop?.id, user_id: selectedStaff?.cid_user },
        })
      );
    }
  }, [selectedStaff?.id, imageShowRank.length]);
  return (
    <div className={`${tab === 2 ? 'relative ' : 'relative'} flex justify-center w-full `}>
      {/* {tab === 2 && ( */}
      <div
        className={`${
          tab === 2 ? 'absolute z-50' : 'opacity-0 pointer-events-none'
        } items-center h-[480px] p-[2.5px] flex justify-center w-full `}
      >
        <div ref={containerRef} className="border-[1px] border-white border-solid w-[40%] h-full">
          {top1_img ? (
            <div className="flex justify-center items-center w-full h-full">
              <img
                className="h-full object-cover"
                src={`${IMAGE_BASE_URL_OF_USER_RANK}/images_rank/${
                  top1_img?.image
                }?v=${Date.now()}`}
                // onError={(e) => {
                //   handleImageError(top1.id);
                //   const target = e.target as HTMLImageElement;
                //   target.onerror = null; // tránh vòng lặp nếu fallback cũng lỗi
                //   target.src = '/fallback.jpg';
                //   console.log('target', target);
                // }}
              />
            </div>
          ) : (
            <DraggableImage
              aspect={458 / 645}
              key={top1.position}
              imageSrc={top1.image}
              zoom={top1.zoom}
              crop={top1.crop}
              position={top1.position}
              onZoomChange={(z) => {
                const newImages = [...images];
                newImages[top1.position].zoom = z;
                setImages(newImages);
              }}
              onCropChange={(crop) => {
                const newImages = [...images];
                newImages[top1.position].crop = crop;
                setImages(newImages);
              }}
              onCropComplete={(_: Area, croppedPixels: Area) => {
                const newImages = [...images];
                newImages[top1.position].croppedAreaPixels = croppedPixels;
                setImages(newImages);
              }}
            />
          )}
        </div>
        <div
          className={`h-full w-[25%] grid grid-rows-2 ${top2_3_img.length > 0 && 'justify-center'}`}
        >
          {top2_3_img.length > 0 ? (
            <>
              {top2_3_img.map((x: any, y: any) => {
                return (
                  <div className="border-[1px] border-white border-solid w-full h-full">
                    <img
                      className="h-full object-cover"
                      src={`${IMAGE_BASE_URL_OF_USER_RANK}/images_rank/${x?.image}?v=${Date.now()}`}
                      // onError={() => {
                      //   handleImageError(x.id);
                      // }}
                    />
                  </div>
                );
              })}
            </>
          ) : (
            <>
              {top2_3.map((img, index) => {
                return (
                  <div className="border-[1px] border-white border-solid w-full h-full">
                    <DraggableImage
                      aspect={282 / 318}
                      key={img.position}
                      imageSrc={img.image}
                      zoom={img.zoom}
                      crop={img.crop}
                      position={img.position}
                      onZoomChange={(z) => {
                        const newImages = [...images];
                        newImages[img.position].zoom = z;
                        setImages(newImages);
                      }}
                      onCropChange={(crop) => {
                        const newImages = [...images];
                        newImages[img.position].crop = crop;
                        setImages(newImages);
                      }}
                      onCropComplete={(_: Area, croppedPixels: Area) => {
                        const newImages = [...images];
                        newImages[img.position].croppedAreaPixels = croppedPixels;
                        setImages(newImages);
                      }}
                    />
                  </div>
                );
              })}
            </>
          )}
        </div>
        <div
          className={`h-full w-[35%] grid grid-rows-3 ${top4_5_img.length > 0 && 'justify-center'}`}
        >
          <div className="grid grid-cols-2 w-full h-full overflow-hidden">
            {top4_5_img.length > 0 ? (
              <>
                {top4_5_img.map((x: any, y: any) => {
                  return (
                    <div className="border-[1px] border-white border-solid w-full h-full">
                      <img
                        className="h-full object-contain"
                        src={`${IMAGE_BASE_URL_OF_USER_RANK}/images_rank/${
                          x?.image
                        }?v=${Date.now()}`}
                        // onError={() => {
                        //   handleImageError(x.id);
                        // }}
                      />
                    </div>
                  );
                })}
              </>
            ) : (
              <>
                {top4_5.map((img, index) => {
                  return (
                    <div className="border-[1px] border-white border-solid w-full h-full">
                      <DraggableImage
                        aspect={196 / 211}
                        key={img.position}
                        imageSrc={img.image}
                        zoom={img.zoom}
                        crop={img.crop}
                        position={img.position}
                        onZoomChange={(z) => {
                          const newImages = [...images];
                          newImages[img.position].zoom = z;
                          setImages(newImages);
                        }}
                        onCropChange={(crop) => {
                          const newImages = [...images];
                          newImages[img.position].crop = crop;
                          setImages(newImages);
                        }}
                        onCropComplete={(_: Area, croppedPixels: Area) => {
                          const newImages = [...images];
                          newImages[img.position].croppedAreaPixels = croppedPixels;
                          setImages(newImages);
                        }}
                      />
                    </div>
                  );
                })}
              </>
            )}
          </div>
          <div className="grid grid-cols-2 w-full h-full overflow-hidden">
            {top6_7_img.length > 0 ? (
              <>
                {top6_7_img.map((x: any, y: any) => {
                  return (
                    <div className="border-[1px] border-white border-solid w-full h-full">
                      <img
                        className="h-full object-contain"
                        src={`${IMAGE_BASE_URL_OF_USER_RANK}/images_rank/${
                          x?.image
                        }?v=${Date.now()}`}
                        // onError={() => {
                        //   handleImageError(x.id);
                        // }}
                      />
                    </div>
                  );
                })}
              </>
            ) : (
              <>
                {top6_7.map((img, index) => {
                  return (
                    <div className="border-[1px] border-white border-solid w-full h-full">
                      <DraggableImage
                        aspect={196 / 211}
                        key={img.position}
                        imageSrc={img.image}
                        zoom={img.zoom}
                        crop={img.crop}
                        position={img.position}
                        onZoomChange={(z) => {
                          const newImages = [...images];
                          newImages[img.position].zoom = z;
                          setImages(newImages);
                        }}
                        onCropChange={(crop) => {
                          const newImages = [...images];
                          newImages[img.position].crop = crop;
                          setImages(newImages);
                        }}
                        onCropComplete={(_: Area, croppedPixels: Area) => {
                          const newImages = [...images];
                          newImages[img.position].croppedAreaPixels = croppedPixels;
                          setImages(newImages);
                        }}
                      />
                    </div>
                  );
                })}
              </>
            )}
          </div>
          <div className="grid grid-cols-3 w-full h-full overflow-hidden">
            {top8_9_10_img.length > 0 ? (
              <>
                {top8_9_10_img.map((x: any, y: any) => {
                  return (
                    <div className="border-[1px] border-white border-solid w-full h-full">
                      <img
                        className="h-full object-contain"
                        src={`${IMAGE_BASE_URL_OF_USER_RANK}/images_rank/${
                          x?.image
                        }?v=${Date.now()}`}
                        // onError={() => {
                        //   handleImageError(x.id);
                        // }}
                      />
                    </div>
                  );
                })}
              </>
            ) : (
              <>
                {top8_9_10.map((img, index) => {
                  return (
                    <div className="border-[1px] border-white border-solid w-full h-full">
                      <DraggableImage
                        aspect={129 / 211}
                        key={img.position}
                        imageSrc={img.image}
                        zoom={img.zoom}
                        crop={img.crop}
                        position={img.position}
                        onZoomChange={(z) => {
                          const newImages = [...images];
                          newImages[img.position].zoom = z;
                          setImages(newImages);
                        }}
                        onCropChange={(crop) => {
                          const newImages = [...images];
                          newImages[img.position].crop = crop;
                          setImages(newImages);
                        }}
                        onCropComplete={(_: Area, croppedPixels: Area) => {
                          const newImages = [...images];
                          newImages[img.position].croppedAreaPixels = croppedPixels;
                          setImages(newImages);
                        }}
                      />
                    </div>
                  );
                })}
              </>
            )}
          </div>
        </div>
      </div>
      {/* )} */}
      <div
        className={`${
          tab === 3 ? 'absolute z-50' : 'opacity-0 pointer-events-none'
        } flex items-center justify-center w-[650px] h-[480px] p-[2.5px] border-solid border border-b-slate-500`}
      >
        <div className="border-[1px] border-white border-solid w-[40%] h-full">
          {top1_img_square ? (
            <>
              <img
                className="w-full h-full object-cover"
                src={`${IMAGE_BASE_URL_OF_USER_RANK}/images_rank/${
                  top1_img_square?.image
                }?v=${Date.now()}`}
              />
            </>
          ) : (
            <DraggableImage
              aspect={253 / 639}
              key={top1_square.position}
              imageSrc={top1_square.image}
              zoom={top1_square.zoom}
              crop={top1_square.crop}
              position={top1_square.position}
              onZoomChange={(z) => {
                const newImages = [...images];
                newImages[top1_square.position].zoom = z;
                setImages(newImages);
              }}
              onCropChange={(crop) => {
                const newImages = [...images];
                newImages[top1_square.position].crop = crop;
                setImages(newImages);
              }}
              onCropComplete={(_: Area, croppedPixels: Area) => {
                const newImages = [...images];
                newImages[top1_square.position].croppedAreaPixels = croppedPixels;
                setImages(newImages);
              }}
            />
          )}
        </div>
        <div className="grid grid-rows-2 w-[25%] h-full">
          {top2_3_img_square.length > 0 ? (
            <>
              {top2_3_img_square.map((x: any, y: any) => {
                return (
                  <div className="border-[1px] border-white border-solid w-full h-full">
                    <img
                      className="w-full h-full object-cover"
                      src={`${IMAGE_BASE_URL_OF_USER_RANK}/images_rank/${x?.image}?v=${Date.now()}`}
                    />
                  </div>
                );
              })}
            </>
          ) : (
            <>
              {top2_3_square.map((img, index) => {
                return (
                  <div className="border-[1px] border-white border-solid w-full h-full">
                    <DraggableImage
                      aspect={156 / 317}
                      key={img.position}
                      imageSrc={img.image}
                      zoom={img.zoom}
                      crop={img.crop}
                      position={img.position}
                      onZoomChange={(z) => {
                        const newImages = [...images];
                        newImages[img.position].zoom = z;
                        setImages(newImages);
                      }}
                      onCropChange={(crop) => {
                        const newImages = [...images];
                        newImages[img.position].crop = crop;
                        setImages(newImages);
                      }}
                      onCropComplete={(_: Area, croppedPixels: Area) => {
                        const newImages = [...images];
                        newImages[img.position].croppedAreaPixels = croppedPixels;
                        setImages(newImages);
                      }}
                    />
                  </div>
                );
              })}
            </>
          )}
        </div>
        <div className="grid grid-rows-3 w-[35%] h-full">
          <div className="grid grid-cols-2 w-full h-full overflow-hidden">
            {top4_5_img_square.length > 0 ? (
              <>
                {top4_5_img_square.map((x: any, y: any) => {
                  return (
                    <div className="border-[1px] border-white border-solid w-full h-full">
                      <img
                        className="w-full h-full object-contain"
                        src={`${IMAGE_BASE_URL_OF_USER_RANK}/images_rank/${
                          x?.image
                        }?v=${Date.now()}`}
                      />
                    </div>
                  );
                })}
              </>
            ) : (
              <>
                {top4_5_square.map((img, index) => {
                  return (
                    <div className="border-[1px] border-white border-solid w-full h-full">
                      <DraggableImage
                        aspect={108 / 210}
                        key={img.position}
                        imageSrc={img.image}
                        zoom={img.zoom}
                        crop={img.crop}
                        position={img.position}
                        onZoomChange={(z) => {
                          const newImages = [...images];
                          newImages[img.position].zoom = z;
                          setImages(newImages);
                        }}
                        onCropChange={(crop) => {
                          const newImages = [...images];
                          newImages[img.position].crop = crop;
                          setImages(newImages);
                        }}
                        onCropComplete={(_: Area, croppedPixels: Area) => {
                          const newImages = [...images];
                          newImages[img.position].croppedAreaPixels = croppedPixels;
                          setImages(newImages);
                        }}
                      />
                    </div>
                  );
                })}
              </>
            )}
          </div>
          <div className="grid grid-cols-2 w-full h-full overflow-hidden">
            {top6_7_img_square.length > 0 ? (
              <>
                {top6_7_img_square.map((x: any, y: any) => {
                  return (
                    <div className="border-[1px] border-white border-solid w-full h-full">
                      <img
                        className="w-full h-full object-contain"
                        src={`${IMAGE_BASE_URL_OF_USER_RANK}/images_rank/${
                          x?.image
                        }?v=${Date.now()}`}
                      />
                    </div>
                  );
                })}
              </>
            ) : (
              <>
                {top6_7_square.map((img, index) => {
                  return (
                    <div className="border-[1px] border-white border-solid w-full h-full">
                      <DraggableImage
                        aspect={108 / 210}
                        key={img.position}
                        imageSrc={img.image}
                        zoom={img.zoom}
                        crop={img.crop}
                        position={img.position}
                        onZoomChange={(z) => {
                          const newImages = [...images];
                          newImages[img.position].zoom = z;
                          setImages(newImages);
                        }}
                        onCropChange={(crop) => {
                          const newImages = [...images];
                          newImages[img.position].crop = crop;
                          setImages(newImages);
                        }}
                        onCropComplete={(_: Area, croppedPixels: Area) => {
                          const newImages = [...images];
                          newImages[img.position].croppedAreaPixels = croppedPixels;
                          setImages(newImages);
                        }}
                      />
                    </div>
                  );
                })}
              </>
            )}
          </div>
          <div className="grid grid-cols-3 w-full h-full overflow-hidden">
            {top8_9_10_img_square.length > 0 ? (
              <>
                {top8_9_10_img_square.map((x: any, y: any) => {
                  return (
                    <div className="border-[1px] border-white border-solid w-full h-full">
                      <img
                        className="w-full h-fit object-contain"
                        src={`${IMAGE_BASE_URL_OF_USER_RANK}/images_rank/${
                          x?.image
                        }?v=${Date.now()}`}
                      />
                    </div>
                  );
                })}
              </>
            ) : (
              <>
                {top8_9_10_square.map((img, index) => {
                  return (
                    <div className="border-[1px] border-white border-solid w-full h-full">
                      <DraggableImage
                        aspect={71 / 210}
                        key={img.position}
                        imageSrc={img.image}
                        zoom={img.zoom}
                        crop={img.crop}
                        position={img.position}
                        onZoomChange={(z) => {
                          const newImages = [...images];
                          newImages[img.position].zoom = z;
                          setImages(newImages);
                        }}
                        onCropChange={(crop) => {
                          const newImages = [...images];
                          newImages[img.position].crop = crop;
                          setImages(newImages);
                        }}
                        onCropComplete={(_: Area, croppedPixels: Area) => {
                          const newImages = [...images];
                          newImages[img.position].croppedAreaPixels = croppedPixels;
                          setImages(newImages);
                        }}
                      />
                    </div>
                  );
                })}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
